import React from 'react';
import { Stack } from '@mui/material';
import CandidateSkillRating from 'shared/components/candidateSkillRating';
import {
  ICandidateInterviewFeedbackOverallRating,
  ICandidateFeedbackResponseItem,
} from 'modules/hiring/models/candidateFeedbackOverallRating.model';
import { InterviewFeedbackQuestionType } from 'models/enum';

export interface ICandidateFeedbackAverageRatingProps {
  feedbackAverageList: ICandidateInterviewFeedbackOverallRating | null;
}

const CandidateInterviewFeedbackAverageRating = ({
  feedbackAverageList,
}: ICandidateFeedbackAverageRatingProps) => {
  return (
    <Stack
      id='candidate-interview-feedback-average-rating'
      data-testid='candidate-interview-feedback-average-rating'
      sx={{
        borderRadius: '1rem',
      }}
    >
      <Stack
        gap='0.5rem'
        sx={{
          mt: '0.3rem',
        }}
      >
        {feedbackAverageList?.agreegateResponse?.responseItemList
          ?.filter(
            (responseItem: ICandidateFeedbackResponseItem) =>
              responseItem?.questionType ===
              InterviewFeedbackQuestionType.LIKART_WITH_NA
          )
          .sort((a, b) => a?.label.localeCompare(b?.label))
          .map((responseItem, itemIndex) => (
            <CandidateSkillRating
              key={itemIndex}
              name={responseItem?.label}
              rating={responseItem?.score}
              showAvg={true}
            />
          ))}
      </Stack>
    </Stack>
  );
};

export default CandidateInterviewFeedbackAverageRating;
